<template>
  <el-dialog :visible.sync="dialogVisible" top="32vh" :before-close="closeDialog" :close-on-click-modal="false">
    <div slot="title" class="el-dialog__title"><div class="title-left"></div><slot name="title">{{$t('personCenterV2.prompt')}}</slot><div class="title-right"></div></div>
    <span>{{ $t('personCenterV2.text') }}</span>
    <span slot="footer" class="dialog-footer">
      <el-button class="btn_cancle" @click="handleClose">{{ $t('personCenterV2.cancle') }}</el-button>
      <el-button type="primary" v-preventReClick="2000" @click="handleSure(companyCode, companyId)">{{ $t('personCenterV2.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { logoutTeam } from '@/services/userInfo'
export default {
  name: 'deleteDialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    companyCode: {
      type: Number,
      default: 0,
    },
    companyId: {
      type: Number,
      default: 0,
    },
  },
  // 监听父组件传递的数据
  // watch: {
  //   MyJoinTeamInfo: function(val) {
  //     console.log(val)
  //     val.forEach((item) => {
  //       this.logOut.id = item.companyId
  //       this.logOut.sourceId = item.companyCode
  //     })
  //   },
  // },
  data() {
    return {
      //  退出登录信息数据
      logOut: {
        id: '',
        sourceId: 0,
        status: 0,
      },
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDeleteDialog')
    },
    // 取消操作
    handleClose() {
      // this.$message({
      //   message: this.$t('personCenterV2.cancleOperation'),
      // })
      this.$emit('closeDeleteDialog')
    },
    // 确定操作
    async handleSure(companyCode, companyId) {
      const self = this;
      let Status = 2
      this.logOut.status = Status
      this.logOut.id = companyId
      this.logOut.sourceId = companyCode
      const { success } = await logoutTeam(this.logOut);

      if (!success) { return; }

      // 如果退出的团队是当前团队，则返回到自己团队
      if (companyCode == (localStorage.getItem("companyCode") || localStorage.getItem("myCompanyCode"))) {
        let selfCompany =JSON.parse(localStorage.getItem("userInfo")).selfCompany;
        let params = Object();
        Reflect.set(params, 'companyCode', selfCompany.code);
        self.$store.dispatch('layout/changeCompanyInfo', params).then(({ result, success, status }) => {
          if (status === 200 && success) {
            let newCompanyList = result.companyList.filter(item => {
              return item.code != companyCode;
            });
            result.companyList = newCompanyList;
            localStorage.setItem('myUser', JSON.stringify(result));
            localStorage.setItem('userInfo', JSON.stringify(result));
            localStorage.setItem('companyCode', selfCompany.code);        // 公司编码
            localStorage.setItem('myCompanyCode', selfCompany.code);      // 公司编码
            self.$nextTick(async () => {
              self.$store.dispatch("layout/newUserInfo", result);
              self.bus.$emit('changeTeam', selfCompany.code);
              self.$store.dispatch('layout/navInfo',  selfCompany.code);
              self.$router.push({ name: 'homeMiddleware' });
            });
          }
        })
      } else {
        // 去除header已退出的下拉框选项
        let userInfo = JSON.parse(localStorage.getItem("userInfo"));
        let newCompanyList = userInfo.companyList.filter(item => {
          return item.code != companyCode;
        });
        userInfo.companyList = newCompanyList;
        this.$store.dispatch("layout/newUserInfo", userInfo);
        this.$parent.getMyJoinTeamInfo();                                 //调用父组件方法
      }
      this.$message.success(this.$t('personCenterV2.logOutSuccess'));
      this.$emit('closeDeleteDialog');
    },
  },
}
</script>

<style lang="less" scoped>
@import './assets/style.less';
</style>
